import type { ClientInvoiceItemDto } from '../../lib/clientInvoiceApi';
import { num, roundQty } from '../../utils/invoiceLineMath';

type ShortLine = Pick<ClientInvoiceItemDto, 'supplierBilledQty' | 'supplierBilledVs' | 'qtyFromStock' | 'qtyFromPantry'> & {
  confirmedQuantity?: unknown;
};

/**
 * Monday demo (meeting 2026-10-31): how much less the supplier billed than the line ordered ("ordered 100 LBS, billed 96,
 * short 4"). Read only from `supplierBilledQty`, which its server owner (buildLineDiscrepancyAlert, D171.4 / D172.5)
 * stores while the bill is short; a figure with no side is short, as the line drawer reads it. Said, never acted on: no
 * tolerance, no accept or reject. null = nothing to show, never 0.
 *
 * A line partly drawn from stock or pantry is null: the server compared the bill with what was left to BUY, which this
 * client cannot work out (that rule lives server-side), so order less bill would overstate the shortage there.
 */
export function supplierShortBy(item: ShortLine): number | null {
  const billed = num(item.supplierBilledQty);
  if (billed === null || item.supplierBilledVs === 'over') return null;
  if ([item.qtyFromStock, item.qtyFromPantry].some((q) => { const drawn = num(q); return drawn !== null && drawn !== 0; })) return null;
  const ordered = num(item.confirmedQuantity);
  if (ordered === null || ordered <= 0) return null;
  const short = roundQty(ordered - billed);
  return short > 0 ? short : null;
}
